module.exports = __webpack_public_path__ + "img/10业务领域-img2.1624f0fd.jpg";